module.exports = __webpack_public_path__ + "static/img/15.0e20e5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15.png
// module id = VlWo
// module chunks = 1